import styled from 'styled-components'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
// components
import { ErrorMessageWrapper } from 'components/UI/ErrorMessage'
// themes
import { colors } from 'themes'

export const Title = styled.div`
  font-weight: 600;
`

export const Description = styled.div`
  margin-top: 4px;
  font-size: 12px;
  opacity: 0.7;
`

export const Mapping = styled.div`
  margin-top: 16px;
`

export const Row = styled.div`
  gap: 12px;
  display: flex;
  align-items: end;

  > div {
    flex: 1;
  }

  > svg {
    align-self: center;
  }
`

export const PropertySelect = styled.div`
  position: relative;
`

// Sits on the select's label line (the 16px band above the control), at its right edge.
export const InfoIcon = styled(InfoOutlinedIcon)`
  top: 0;
  right: 0;
  position: absolute;
  font-size: 16px !important;
  opacity: 0.6;
  cursor: help;
`

// The select's error hangs at a fixed `bottom: -20px`, so a wrapped one grows up over the control.
// Anchored to the control's bottom instead, an error that wraps grows downwards.
export const SourceFieldSelect = styled.div`
  ${ErrorMessageWrapper} {
    top: 100%;
    bottom: auto;

    > div {
      margin-top: 0;
    }
  }
`

export const Hint = styled.div`
  margin-top: 12px;
  font-size: 12px;
  opacity: 0.75;
`

export const ValueMapWrapper = styled.div`
  gap: 4px;
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  padding: 12px;
  border-radius: 4px;
  background-color: ${colors.gray210};
`

export const ValueMapTitle = styled.div`
  font-size: 12px;
`
